import React from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { useDispatch } from 'react-redux';
import { hideLoadingIndicator, showLoadingIndicator } from 'redux/modules/api/loadingIndicator/actions';
import { finalize } from 'rxjs/operators';
import { primaryColor } from 'assets/jss/material-dashboard-pro-react';
import { translate } from 'components/Translation';
import Button from 'components/CustomButtons/Button';
import { SingleRequest } from 'utils/api/models/requests/singleRequest';
import { RequestsService } from 'services/requests/requests';
import { setToast } from 'redux/modules/toast/actions';
import { HeadingLBold } from 'components/Typography/Typography';
import { InfoOutlined } from '@material-ui/icons';

interface IActivityDetailsProps {
	userRequest: SingleRequest | null;
	isOpen: boolean;
	turnOffDialog: () => void;
	refetchUserRequests: () => void;
}

export enum Status {
	ACCEPTED = 'ACCEPTED',
	REJECTED = 'REJECTED',
	PENDING = 'PENDING',
	NEW = 'NEW',
}

const RejectRequestDialog = ({ userRequest, isOpen, turnOffDialog, refetchUserRequests }: IActivityDetailsProps) => {
	const dispatch = useDispatch();

	const updateUserRequest = (status: Status) => {
		if (userRequest) {
			dispatch(showLoadingIndicator());
			RequestsService.updateUserRequest({
				userReqId: userRequest?.userReqId,
				status: status,
			})
				.pipe(finalize(() => dispatch(hideLoadingIndicator())))
				.subscribe(
					({ response }) => {
						if (response?.status === true) {
							refetchUserRequests();
							turnOffDialog();
						} else {
							dispatch(
								setToast({
									error: true,
									label: translate('service.request.update.user.request.error'),
								})
							);
						}
					},
					() => {
						dispatch(
							setToast({
								error: true,
								label: translate('service.request.update.user.request.error'),
							})
						);
					}
				);
		}
	};

	const handleDeny = () => {
		updateUserRequest(Status.REJECTED);
	};

	return (
		<CustomDialog
			isOpen={isOpen}
			hideDialog={turnOffDialog}
			width={588}
			dialogBody={
				<div style={{ overflowX: 'hidden' }}>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							marginBottom: '12px',
						}}
					>
						<InfoOutlined style={{ color: primaryColor[0], fontSize: '32px' }} />
					</div>
					<div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
						<HeadingLBold>{translate('service.requests.reject.header')}</HeadingLBold>
					</div>
					<div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
						<Button color="secondary-light" onClick={turnOffDialog}>
							{translate('back')}
						</Button>
						<Button
							color="primary-light"
							onClick={handleDeny}
							disabled={
								userRequest?.status === Status.REJECTED || userRequest?.status === Status.ACCEPTED
							}
						>
							{translate('service.requests.reject')}
						</Button>
					</div>
				</div>
			}
		/>
	);
};

export default RejectRequestDialog;
